var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32266 0.889422L8.11305 6.67992C8.24686 6.81373 8.32031 6.99213 8.32031 7.1865C8.32031 7.37695 8.24686 7.55547 8.11305 7.68906L2.32815 13.4742C2.19424 13.608 2.01573 13.6816 1.82528 13.6816C1.63482 13.6816 1.4562 13.6081 1.3224 13.4742L0.896357 13.0481C0.762551 12.9143 0.688673 12.7357 0.688673 12.5452C0.688673 12.3548 0.762551 12.1763 0.896357 12.0424L5.75424 7.18449L0.890755 2.32122C0.757056 2.18741 0.683284 2.0089 0.683284 1.81834C0.683284 1.62788 0.757056 1.44948 0.890755 1.31557L1.31701 0.889422C1.59424 0.6123 2.04543 0.6123 2.32266 0.889422Z",
    fill: "#39695B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRightArrow);
export default __webpack_public_path__ + "static/media/greenRightArrow.56e18b18a1de34bf25ced5d29d539f5c.svg";
export { ForwardRef as ReactComponent };